/** @format */

import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20">
      <div className="w-full lgl:w-1/2">
        <div className="py-12 flex flex-col gap-4 ">
          <h2 className="text-4xl font-bold">Job Experience</h2>
          <p className="text-gray-500">
            Below is a summary of my professional work experience.
          </p>
        </div>
        <div className="mt-5 w-full h-[1500px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10 mb-10">
          <ResumeCard
            title="Fullstack Engineer"
            subTitle="Useful Media - (December 2023 - Febuary 2024)"
            result="Lagos, Nigeria"
            des="** Collaborated with a team to build a document automation system, enabling
                    organizations and individuals to effectively manage, create, sign, and update
                    various types of documents. Utilized RESTful APIs, React, and PHP.."
          />
          <ResumeCard
            title="Software Engineer"
            subTitle="Decagon Institute - (January 2023 - November 2023)"
            result="Lagos, Nigeria"
            des="**Collaborated with a team to successfully develop a Savings Application by implementing RESTful API using Asp.Net Technology, React and Paystack.
                **Created a high-performing RESTful API for an online E-Library system using ASP.NET Core and Entity Framework, enhancing user experience and improving productivity .
                **Integrated various APIs with front-end in React, Blazor and MVC Architecture.
                **Developed skills in remote pair-programming using GitHub, Daily Stand-ups, and industry standard git flow and an Agile approach to collaborate with other Developers."
          />
          <ResumeCard
            title="Trainee Software Engineer"
            subTitle="ALX-Africa - (December 2022 - present)"
            result="Lagos, Nigeria"
            des="**Spent 1000+ hours mastering git, Vim, and other command line tools, algorithms and various data structures , Programming basics while simultaneously developing projects using C#, React and JavaScript.
                  **Developed skills in remote pair-programming using GitHub, Daily Stand-ups, and industry standard git flow to collaborate with international remote developers."
          />
          <ResumeCard
            title=" Freelance Frontend Engineer"
            subTitle="UpWork, Fiver, … - October 2020 – January 2023"
            result="Remote"
            des="**Created and maintained responsive, user-friendly web applications for diverse clients, leveraging HTML, CSS, and JavaScript to deliver intuitive user interfaces and exceptional experiences.. 
                **Partnered with clients and project managers to define project scope and requirements, showcasing technical expertise to deliver high-quality work within strict timelines and provided technical support and troubleshooting as needed."
          />
        </div>
      </div>
      <div className="w-full lgl:w-1/2">
        <div className="py-12 flex flex-col gap-4">
          <h2 className="text-4xl font-bold">Training</h2>
          <p className="text-gray-500">
            Here are the details of my relevant training programs.
          </p>
        </div>
        <div className="mt-5 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10 mb-10">
          <ResumeCard
            title="Fullstack Software Engineering Training"
            subTitle="Decagon Institute"
            result=""
            des="I underwent an intensive Fullstack Software Engineering training at Decagon Institute, 
            adhering to industry standards. The program covered a comprehensive curriculum including agile methodologies, 
            agile leadership, and professional ethics. During this training, I gained expertise in building scalable and efficient web applications using cutting-edge technologies such as React, 
            ASP.NET Core, and more. "
          />

          <ResumeCard
            title="Certificate of Completion: React Learning Program Andela"
            subTitle="Andela/Meta React Learning Program"
            result=""
            des="I successfully completed a comprehensive React certification program offered by Andela. The program, spanning 7 weeks, included extensive video content and practical courses on Pluralsight. 
            Throughout the program, I gained in-depth knowledge of React and its ecosystem, enhancing my skills in building modern and efficient web applications."
          />

          <ResumeCard
            title="Astra Fellowship and Leadership Training"
            subTitle="Astra"
            result=""
            des="I participated in the Astra Fellowship, a comprehensive leadership and entrepreneurship skills program.  Through Astra, I learned essential skills for navigating the dynamic landscape of the tech industry, fostering innovation, and contributing to the growth of startups. The program equipped me with the knowledge and mindset required to excel in leadership roles and make impactful contributions to the software development ecosystem."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Experience;
